import React, { useEffect, useState, useCallback } from "react";
import "./EditUserInformation.scss";
import { useSelector, useDispatch } from "react-redux";
import {setUserInformation} from "../../../storage/reducers/userInformationReducer";
import editIcon from "./edit.svg";
import { useTranslation } from "react-i18next";
import { EDIT_USER_PROFILE_LINKS_BY_ENV, replaceableJobTitles, USER_DETAILS } from "../../../helper/constants";
import { USER_INFO_API_PATH } from "../../../helper/APIPaths";
import Tooltip from "@mui/material/Tooltip";

interface IUser {
    username: string;
    role: string;
}

const EditUserInformation: React.FC = () => {
    const {DEFAULT_NAME, DEFAULT_ROLE_INTERNAL_USER, DEFAULT_ROLE_EXTERNAL_USER, TOOLTIP_TEXT} =  USER_DETAILS;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { hid } = useSelector((state: any) => state.config);
    const [user, setUser] = useState<IUser | null>(null);
    const [error, setError] = useState<boolean>(true);
    // const [retryCount, setRetryCount] = useState<number>(0); 
    const {userIformation} = useSelector((state: any) => state.userInformation);
    const { portalPermissions } = useSelector((state: any) => state.config);
    const configData = useSelector((state: any) => state.config?.configData || {});
    const internalUser = portalPermissions?.result?.isInternal; 

    const fetchUserInformation = useCallback(async () => {
        try {
            const response = await fetch(USER_INFO_API_PATH,{
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({honId:hid}),
            });
            const res = await response.json();
            const dataUser = res?.data;
            if (dataUser) {
                dispatch(setUserInformation(dataUser));
                setUser({ 
                    username: dataUser?.name || t(DEFAULT_NAME), 
                    role: dataUser?.jobTitle 
                });
                setError(false);
            }
        } catch (ierror) {
            console.error("Error while fetching user information", ierror);
            setError(true);
        }
    }, []);


    useEffect(() => {
        if ((!userIformation && !user) && (internalUser != undefined)) {
            fetchUserInformation();
        }else if(userIformation){
            setUser({ username: userIformation?.name, role: userIformation?.jobTitle });
        }
    }, [userIformation, user, fetchUserInformation, internalUser]);

    const replaceJobTitle = (jobTitle: string) => {
        if (replaceableJobTitles.includes(jobTitle.toLowerCase())) {
            return t(DEFAULT_ROLE_EXTERNAL_USER);
        } 
        return jobTitle;
    };

    const getUserRole = () => {
        if (user?.role) return user.role;
        if (internalUser && internalUser !== undefined) return t(DEFAULT_ROLE_INTERNAL_USER);
        return t(DEFAULT_ROLE_EXTERNAL_USER);
    };

    const userClass = internalUser || internalUser == undefined ? "internalUser" : "externalUser";

    return (
        <>
            {
                !error && (
                <Tooltip title={t(TOOLTIP_TEXT)} placement="right" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: "#384348",
                                fontFamily: "PP Telegraf",
                                fontWeight: "400",
                                color: "#FFFFFF",
                            },
                        },
                        arrow: {
                            sx: {
                                color: "#384348",
                            },
                        },
                    }}
                >
                    <div className={`editUserContainer ${userClass}`}>
                            <a 
                            href={EDIT_USER_PROFILE_LINKS_BY_ENV(configData.TECHPUB_APP_ID?.APP_ID)} 
                            target="_blank"
                            rel="noreferrer"
                            >
                                <img 
                                src={editIcon} 
                                className="editIcon"
                                alt="Edit Icon"
                                title=" " 
                                aria-label="Edit Icon"
                                aria-labelledby="Edit Icon"
                                role="button"
                            />
                        </a>
                        <p
                        className={`user ${userClass}`}
                        onClick={() => window.open(EDIT_USER_PROFILE_LINKS_BY_ENV(configData.TECHPUB_APP_ID?.APP_ID), '_blank', 'noopener,noreferrer')}
                        style={{ cursor: 'pointer' }}
                        >
                        {user?.username} ({getUserRole()})
                        </p>
                    </div>
                </Tooltip>
            )}
        </>
    );
};

export default EditUserInformation;